import { CodePreviewFormat } from '../const';
import { appI18n } from '../i18n';

export const getCodePreviewEnum = () => ({
  [CodePreviewFormat.splitView]: appI18n.t('pkg_common.mermaid.default'),
  [CodePreviewFormat.code]: appI18n.t('pkg_common.mermaid.code_only'),
  [CodePreviewFormat.preview]: appI18n.t('pkg_common.mermaid.preview_only'),
});

// 保留旧的导出以保持兼容性，但使用 getter 延迟求值
export const codePreviewEnum = {
  get [CodePreviewFormat.splitView]() {
    return appI18n.t('pkg_common.mermaid.default');
  },
  get [CodePreviewFormat.code]() {
    return appI18n.t('pkg_common.mermaid.code_only');
  },
  get [CodePreviewFormat.preview]() {
    return appI18n.t('pkg_common.mermaid.preview_only');
  },
};

const whiteList = ['mermaid'];

export const codePreviewOptions = Object.entries(CodePreviewFormat).map(([_, value]) => ({
  get title() {
    return getCodePreviewEnum()[value];
  },
  value,
}));

export const codeLanguageCanView = (
  language = '',
  viewMode: string = CodePreviewFormat.splitView
) => {
  let button = true;
  let preview = true;
  let code = true;

  if (viewMode === CodePreviewFormat.code) {
    preview = false;
  }

  if (viewMode === CodePreviewFormat.preview) {
    code = false;
  }

  if (!whiteList.includes(language.toLocaleLowerCase())) {
    button = false;
    preview = false;
  }

  return {
    button,
    preview,
    code,
  };
};
